import styled from 'styled-components';

import { mediaQuery } from '../../../../../styles/global';

export const Content = styled.div`
  padding: 160px 0 0;

 ${mediaQuery.maxWidth.tablet} {
    padding: 112px 0 0;
  }
`;

export const Caption = styled.h3`
  font-family: ${({ theme }) => theme.fontFamily.bold};
  color: ${({ theme }) => theme.colors.white};
  font-size: 3rem;
  margin: 0;
  line-height: 100%;

  ${mediaQuery.maxWidth.phone} {
    font-size: 2rem;
  }
`;

export const SubCaption = styled.p`
  font-family: ${({ theme }) => theme.fontFamily.medium};
  letter-spacing: 0.2em;
  font-size: 10px;
  text-transform: uppercase;
`;

export const Text = styled.p`
  font-family: ${({ theme }) => theme.fontFamily.regular};
  line-height: 170%;
`;

export const CardsWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
  margin: 72px 0 160px;
  padding: 0 20px;
  
  ${mediaQuery.maxWidth.tablet} {
    margin: 32 0 112px;
  }

  ${mediaQuery.maxWidth.phone} {
    justify-content: start;
    flex-wrap: nowrap;
    overflow-x: auto;
    scroll-behavior: smooth;
    cursor: grab;

    &::-webkit-scrollbar {
    display: none;
  }
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  padding: 0 20px;
`;

export const TextWrapper = styled.div``;

export const WaveImage = styled.img`
  position: absolute;
  right: 0;

  ${mediaQuery.maxWidth.tablet} {
    right: -300px;
  }
`;

export const ViewSwitcher = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 20px 40px;
`;

export const Divider = styled.div`
  height: 1px;
  background-color: rgba(255, 255, 255, 0.2);
  margin-left: 20px;
  margin-right: 20px;
`;